var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundManager(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background_manager",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29097",
    "data-name": "Path 29097",
    d: "M9.6,20h4.8c4,0,5.6-1.6,5.6-5.6V9.6c0-4-1.6-5.6-5.6-5.6H9.6C5.6,4,4,5.6,4,9.6v4.8C4,18.4,5.6,20,9.6,20Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29098",
    "data-name": "Path 29098",
    d: "M8.01,4V2M12,4V2m4,2V2m4,6h2m-2,4h2m-2,4h2m-6,4v2m-3.99-2v2m-4-2v2M2,8H4M2,12H4M2,16H4m6.5,1h3C16,17,17,16,17,13.5v-3C17,8,16,7,13.5,7h-3C8,7,7,8,7,10.5v3C7,16,8,17,10.5,17Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundManager);
export default __webpack_public_path__ + "static/media/background_manager.fcb0cdab9154d790b85668cf76565d72.svg";
export { ForwardRef as ReactComponent };